<template>
  <div v-if="hasData" class="card shadow-sm">
    <div class="card-body">
      <div class="row">
        <div class="col-md-3">
          <div class="detection-details">
            <div class="detection-header mb-1">
              <b-badge
                v-if="item.subtype"
                :variant="getDetectionBadgeVariant(item.subtype)"
                class="ms-1"
              >
                {{ item.subtype.toUpperCase().replace("_", " ") }}
              </b-badge>
              <!--<b-badge variant="primary">{{ item.data.provider }}</b-badge>-->
            </div>
            <div class="info-grid">
              <!--<div class="info-item">
                <span class="info-label">{{ $t("alarm.timeline.type") }}:</span>
                <span class="info-value">{{
                  item.subtype || $t("alarm.timeline.detection")
                }}</span>
              </div>-->
              <!--<div class="info-item">
                <span class="info-label">{{ $t("alarm.timeline.provider") }}:</span>
                <span class="info-value">{{ item.data.provider }}</span>
              </div>-->
              <div
                v-if="
                  item.data.event_data &&
                  typeof item.data.event_data === 'object' &&
                  !Array.isArray(item.data.event_data) &&
                  item.data.event_data.age
                "
                class="info-item"
              >
                <span class="info-label">{{ $t("alarm.timeline.age") }}:</span>
                <span class="info-value">{{ item.data.event_data.age }} años</span>
              </div>
              <div
                v-if="
                  item.data.event_data &&
                  typeof item.data.event_data === 'object' &&
                  !Array.isArray(item.data.event_data) &&
                  item.data.event_data.glasses
                "
                class="info-item"
              >
                <span class="info-label">{{ $t("alarm.timeline.glasses") }}:</span>
                <span class="info-value">{{
                  item.data.event_data.glasses === "yes"
                    ? $t("alarm.timeline.yes")
                    : $t("alarm.timeline.no")
                }}</span>
              </div>
              <div
                v-if="
                  item.data.event_data &&
                  typeof item.data.event_data === 'object' &&
                  !Array.isArray(item.data.event_data) &&
                  item.data.event_data.hasOwnProperty('list')
                "
                class="info-item"
              >
                <span class="info-label">{{ $t("alarm.timeline.list") }}:</span>
                <span class="info-value">
                  <b-badge v-if="item.data.event_data.list" variant="warning">{{
                    item.data.event_data.list
                  }}</b-badge>
                  <span v-else class="text-muted">null</span>
                </span>
              </div>
              <div
                v-if="
                  item.data.event_data &&
                  typeof item.data.event_data === 'object' &&
                  !Array.isArray(item.data.event_data) &&
                  item.data.event_data.predominant_emotion
                "
                class="info-item"
              >
                <span class="info-label">{{ $t("alarm.timeline.emotion") }}:</span>
                <span class="info-value">{{
                  item.data.event_data.predominant_emotion
                }}</span>
              </div>
              <div
                v-if="
                  item.data.event_data &&
                  typeof item.data.event_data === 'object' &&
                  !Array.isArray(item.data.event_data) &&
                  item.data.event_data.score
                "
                class="info-item"
              >
                <span class="info-label">{{ $t("alarm.timeline.score") }}:</span>
                <span class="info-value">{{ item.data.event_data.score }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-9 d-flex align-items-center" v-if="item.data.image">
          <img
            :src="item.data.image"
            alt="Detection Event"
            class="img-fluid timeline-image"
            @click="openImageModal(item.data.image)"
            v-b-modal.image_modal
          />
        </div>
      </div>
      <div v-if="item.to && item.total" class="mt-2 alert alert-info mb-0">
        <small>
          <strong>{{
            $t("alarm.timeline.event_info", { to: item.to, total: item.total })
          }}</strong>
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import { BBadge } from "bootstrap-vue";
import store from "@/store";

export default {
  name: "DetectionEventItem",
  components: {
    BBadge,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const hasData = computed(() => {
      return props.item?.data && Object.keys(props.item.data).length > 0;
    });

    const openImageModal = async (imageUrl) => {
      await store.dispatch("image_modal/imageUrl", imageUrl);
    };

    const getDetectionBadgeVariant = (subtype) => {
      const subtypeLower = subtype.toLowerCase();
      if (subtypeLower === "fr") {
        return "success";
      } else if (subtypeLower === "lpr") {
        return "warning";
      } else if (subtypeLower === "smoke_detection") {
        return "danger";
      } else if (subtypeLower.includes("detection")) {
        return "info";
      }
      return "secondary";
    };

    return {
      hasData,
      openImageModal,
      getDetectionBadgeVariant,
    };
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/variables/_variables.scss";

.detection-details {
  border-radius: 0.5rem;
  padding-top: 0rem;
}

.detection-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.info-grid {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.25rem;
  border-bottom: 1px solid #f1f1f1;
}

.info-item:last-child {
  border-bottom: none;
}

.info-label {
  font-weight: 600;
  color: #495057;
  font-size: 0.9rem;
}

.info-value {
  text-align: right;
  flex-grow: 1;
  padding-left: 1rem;
}

.timeline-image {
  border-radius: 0.5rem;
  border: 1px solid #dee2e6;
  max-height: 230px;
  object-fit: contain;
  //width: 100%;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.timeline-image:hover {
  transform: scale(1.03);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.alert {
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  margin-bottom: 1rem;
}

@media (max-width: 768px) {
  .info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
  }

  .info-value {
    text-align: left;
    padding-left: 0;
  }

  .timeline-image {
    margin-top: 1rem;
    max-height: 180px;
  }
}
</style>
